import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: ${({ copyContainerHeight }) =>
    copyContainerHeight ? `${copyContainerHeight}px` : 'auto'};
  overflow: hidden;
  margin-bottom: 30px;

  .copy--all-copy-container {
    display: flex;
    flex-direction: column;
  }

  .copy--copy-container.last {
    margin-bottom: 0;
  }

  .copy--copy-container {
    display: flex;
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;

    .progress-bar-container {
      background: #ccc;
    }

    .progress-bar {
      background: #ccc;
      height: 100%;
      width: 5px;
      display: block;
      position: absolute;
      border-radius: 10px;
    }

    .progress-bar.active {
      &:after {
        content: '';
        height: 300px;
        background: var(--blue-5);
        animation: loader 8s;
        animation-iteration-count: 1;
        bottom: 0px;
        width: 5px;
        margin-left: 0;
        border-radius: 10px;
        position: absolute;
      }

      @keyframes loader {
        0% {
          height: 0%;
          top: 0;
          bottom: 0;
        }
        100% {
          height: 100%;
          top: 0;
          bottom: 100%;
        }
      }
    }

    .progress-bar.inactive {
      &:after {
        content: '';
        height: 100%;
        background: #ccc;
        bottom: 0px;
        width: 5px;
        margin-left: 0;
        border-radius: 10px;
        position: absolute;
      }
    }
  }

  h5 {
    max-width: 100%;
  }

  .copy--copy-container.active {
    h5 {
      margin-bottom: 15px;
    }
  }

  .copy--copy-container.active.initial-complete {
    h5 {
      color: var(--neutral-7);
    }

    .rich-text--container {
      animation: 2s slide-down;
      opacity: 1;
      margin-top: 0;

      ul {
        margin-bottom: 0;
        padding-left: 0;
      }

      @keyframes slide-down {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
    }
  }

  .copy--copy-container.active.first {
    h5 {
      color: var(--neutral-7);
    }
    .rich-text--container {
      opacity: 1;
      margin-top: 0;

      ul {
        margin-bottom: 0;
        padding-left: 0;
      }
    }
  }

  .copy--copy-container {
    .rich-text--container {
      opacity: 0;
      margin-top: -1000px;
    }

    h5 {
      color: #ccc;
      margin-bottom: 0;
      width: max-content;

      &:hover {
        cursor: pointer;
        color: var(--neutral-7) !important;
      }
    }
  }

  .myProgress {
    height: 100%;
    width: 5px;
    display: inline-block;
    position: absolute;
    border-radius: 10px;
  }

  .myBar.active {
    transition: all ease-in 0.2s;
    height: 0%;
    width: 5px;
    background: var(--blue-5);
    border-radius: 10px;
  }

  .myBar.inactive {
    height: 0%;
  }

  .copy--copy-container.inactive.initial-complete {
    h5 {
      color: #ccc;
      margin: 0;
    }

    .rich-text--container {
      animation: 1s slide-up;
      opacity: 0;
      margin-top: -1000px;

      @keyframes slide-up {
        0% {
          opacity: 1;
          margin-top: 0;
        }

        10% {
          opacity: 0;
        }

        100% {
          margin-top: -1000px;
        }
      }
    }
  }

  .copy--copy-container.inactive.initial-complete.no-exit-transition {
    .rich-text--container {
      opacity: 0 !important;
    }
  }

  .copy--get-demo-cta {
    margin-top: 10px;
    padding: 12px 18px;
  }

  .copy--copy {
    padding-left: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 100%;
  }

  .copy--copy-rich-text {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    a {
      width: max-content;
    }
  }

  .rich-text--container {
    display: block;
  }

  .copy--progress-bar {
    float: left;
    width: 10px;
    background: var(--blue-5);
    border-radius: 10px;
  }
`;

export { Container };
